module.exports = __webpack_public_path__ + "img/continental-logo.70353909.png";